import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
 html, body {
   max-width: 600px;
   margin: 0 auto;
 }
 
 body {
  box-sizing: border-box;
  margin: 0;
 }
 
 #root {
  box-sizing: border-box;
 }
 
 div.Mui-error > input {
   border-color: #C50000 !important;
 }

 input.Mui-disabled::placeholder {
   color: red !important;
 }
`;
